"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aclResources = void 0;
var aclResources;
(function (aclResources) {
    aclResources["company"] = "res_company";
    aclResources["user"] = "res_user";
    aclResources["user_group"] = "res_user_group";
    aclResources["settings_general"] = "res_general_settings";
    aclResources["settings_access"] = "res_access_settings";
    aclResources["settings_styles"] = "res_settings_styles";
    aclResources["avatar"] = "res_avatar";
    aclResources["ai"] = "res_ai";
    aclResources["knowledge"] = "res_knowledge";
    aclResources["project"] = "res_project";
    aclResources["onboarding"] = "res_onboarding";
    aclResources["reports"] = "res_reports";
    aclResources["payment"] = "res_payment";
    aclResources["botTest"] = "res_bot_test";
})(aclResources || (exports.aclResources = aclResources = {}));
